import { Navigate } from 'react-router-dom'
import { get } from '@/lib/storage'

type Role = 'Admin'|'Dispatcher'|'Loader'|'Trucker'|'Accountant'

export default function RouteGuard({
  roles,
  children,
}: {
  roles: Role[]
  children: React.ReactNode
}) {
  const role = get<Role>('role','Admin')
  if (!roles.includes(role)) return <Navigate to="/unauthorized" replace />
  return <>{children}</>
}
